import * as React from "react"

import * as styles from "./index.module.scss"

interface DotsProps {
  dots: React.ReactNode
}

const DotsContainer: React.FC<DotsProps> = ({ dots }) => {
  return (
    <div className={`${styles.dotsContainer} custom-slick-paging`}>
      <ul> {dots} </ul>
    </div>
  )
}

export default DotsContainer
